<template>
    <van-overlay :show="visible" @click="visible = false">
        <div class="wrapper">
            <img :src="finalImageBase64" alt="">
        </div>
    </van-overlay>
</template>
<script setup>
import { ref } from 'vue'
import QRCode from 'qrcode'

const props = defineProps({
    url: {
        type: String,
        default: ''
    }
})

const visible = ref(false)
const finalImageBase64 = ref('')

const generateShareImage = async (url, title, type) => {
    return new Promise(async (resolve, reject) => {
        try {
            const canvas = document.createElement('canvas')
            canvas.width = 280
            canvas.height = 500
            const ctx = canvas.getContext('2d')

            const bgImage = await loadImage(type == 1 ? 'https://jsl-mall.oss-cn-shenzhen.aliyuncs.com/img/share-dialog-1.png' : 'https://jsl-mall.oss-cn-shenzhen.aliyuncs.com/img/share-dialog-2.png')
            ctx.drawImage(bgImage, 0, 0, 280, 500)

            const qrCodeData = await QRCode.toDataURL(url, {
                width: 160,
                height: 160,
                color: {
                    dark: '#000000',
                    light: '#ffffff'
                }
            })
            const qrImage = await loadImage(qrCodeData)

            const qrX = (280 - 160) / 2 - 10
            const qrY = (500 - 160) / 2 + 30
            ctx.drawImage(qrImage, qrX, qrY, 160, 160)

            ctx.fillStyle = '#000000'
            ctx.font = '14px "微软雅黑"'

            drawText(ctx, title, 130, 150, 160, 22)

            const base64 = canvas.toDataURL('image/png')
            resolve(base64)
        } catch (error) {
            reject(error)
        }
    })
}

function drawText(ctx, text, x, y, maxWidth, lineHeight) {
    ctx.save();
    ctx.textAlign = 'center';
    ctx.textBaseline = 'top';
    
    // 计算第一行能容纳的字符
    let firstLine = '';
    let secondLine = '';
    let remaining = text;
    
    // 先测试是否能一行显示
    if (ctx.measureText(text).width <= maxWidth) {
        // 单行显示，垂直居中
        ctx.fillText(text, x, y + lineHeight / 2);
        ctx.restore();
        return;
    }
    
    // 第一行：逐字测量，直到超出宽度
    for (let i = 0; i < text.length; i++) {
        let testLine = firstLine + text[i];
        if (ctx.measureText(testLine).width > maxWidth) {
            remaining = text.substring(i);
            break;
        }
        firstLine = testLine;
    }
    
    // 如果还有剩余文字，处理第二行
    if (remaining.length > 0) {
        for (let i = 0; i < remaining.length; i++) {
            let testLine = secondLine + remaining[i];
            if (ctx.measureText(testLine).width > maxWidth - 20) { // 留出省略号的宽度
                secondLine += '...';
                break;
            }
            secondLine = testLine;
        }
        
        // 如果没有添加省略号且还有更多文字
        if (!secondLine.endsWith('...') && secondLine.length < remaining.length) {
            secondLine += '...';
        }
        
        // 如果没有超出第二行宽度，直接使用剩余文字
        if (secondLine === '') {
            secondLine = remaining;
            if (ctx.measureText(secondLine).width > maxWidth - 20) {
                secondLine = secondLine.substring(0, secondLine.length - 3) + '...';
            }
        }
    }
    
    // 绘制两行文字，垂直居中
    ctx.fillText(firstLine, x, y);
    if (secondLine) {
        ctx.fillText(secondLine, x, y + lineHeight);
    }
    
    ctx.restore();
}


const loadImage = (src) => {
    return new Promise((resolve, reject) => {
        const img = new Image()
        img.crossOrigin = 'anonymous'
        img.onload = () => resolve(img)
        img.onerror = reject
        img.src = src
    })
}

defineExpose({
    show(url, title, type = 1) {
        if(url.indexOf('?') == -1) {
            url += '?'
        } else {
            url += '&'
        }
        url += 'share=1'
        generateShareImage(url, title, type).then(base64 => {
            finalImageBase64.value = base64
            visible.value = true
        })
    }
})


</script>
<style scoped lang="scss">
.wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;

    img {
        width: 280rem;
        height: 500rem;
    }
}
</style>
